import cartReducer from '../ducks/cart';
import specTableReducer from '../ducks/specTable';
import authReducer from '../ducks/auth';
import i18nReducer from '../ducks/i18n';
import storeReducer from '../ducks/store';
import { loadingBarReducer } from 'react-redux-loading-bar';

const staticReducers = {
  cart: cartReducer,
  loadingBar: loadingBarReducer,
  specTable: specTableReducer,
  i18n: i18nReducer,
  store: storeReducer,
  auth: authReducer
};

export default staticReducers;
